import {noop} from 'lodash';
import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {InfoBubblePillVariantsEnum} from '../../../common/infoBubbles/infoBubblePill';
import {EducationTip} from '../../../educationTips/educationTip';
import {generateStepText} from '../../welcome/onboardingWelcomeHelpers';
import {SandboxEducationTipProps} from './sandboxEducationTip';

/*
 * Component.
 */

export const AssignTabEducationTip: FC<SandboxEducationTipProps> = (props) => {
  const stepCounter = generateStepText(1, 4);
  return (
    <EducationTip
      anchor={props.anchor}
      position="bottom"
      isVisible={props.isVisible}
      isStandalone
      onRequestClose={noop}
      pillType={InfoBubblePillVariantsEnum.EDUCATION}
      title={
        <Trans id="infobubble-onboarding-assign-tab-title-showcase-growth">
          Next, click on the &ldquo;Assigned&rdquo; tab
        </Trans>
      }
      stepCounter={stepCounter}
      dataObjectName={OnboardingDataEventObject.DEMO_ASSIGN}
    >
      {
        <Trans id="infobubble-onboarding-assign-tab-description-showcase-growth">
          Let&apos;s use another message assigned to a new teammate, Brandon, to see how Front rules help
          boost efficiency.
        </Trans>
      }
    </EducationTip>
  );
};
